import React, { createContext, Dispatch, useState, useEffect } from "react";
import BrowserStorage from "../config/core/BrowserStorage";
import {
  ProductPreviewProps,
  FLR,
  InstagramResponseData,
  FLR_BS,
} from "../Types";
import CanvasLoader from "../global/components/CanvasLoader";

interface UserProviderProps {
  children: JSX.Element;
}

interface UserContextTypes {
  globalLoader: boolean;
  setGlobalLoader: Dispatch<boolean>;
  editPageScrollScroll: (arg: string) => void;
  productPreview: ProductPreviewProps | null;
  setProductPreview: Dispatch<ProductPreviewProps | null>;
  isLoading: boolean;
  setIsLoading: Dispatch<boolean>;
  isOrderFinished: boolean;
  setIsOrderFinished: Dispatch<boolean>;
  facebookResponseData: FLR | FLR_BS | null;
  setFacebookResponseData: Dispatch<FLR | FLR_BS | null>;
  instagramResponseData: InstagramResponseData | null;
  setInstagramResponseData: Dispatch<InstagramResponseData | null>;
}

const USER_CONTEXT_INITIAL_VALUES = {
  globalLoader: false,
  setGlobalLoader: (arg: boolean) => undefined,
  editPageScrollScroll: (overflow: string) => undefined,
  productPreview: null,
  setProductPreview: (productPreview: ProductPreviewProps | null) => undefined,
  isLoading: false,
  setIsLoading: (arg: boolean) => undefined,
  isOrderFinished: false,
  setIsOrderFinished: (arg: boolean) => undefined,
  facebookResponseData: null,
  setFacebookResponseData: (facebookResponseData: FLR | FLR_BS | null) =>
    undefined,
  instagramResponseData: null,
  setInstagramResponseData: (
    instagramResponseData: InstagramResponseData | null
  ) => undefined,
};

export const AppContext = createContext<UserContextTypes>({
  ...USER_CONTEXT_INITIAL_VALUES,
});

function AppProvider({ children }: UserProviderProps) {
  // global loaders handlers
  const [globalLoader, setGlobalLoader] = useState<boolean>(false);
  const [
    productPreview,
    setProductPreview,
  ] = useState<ProductPreviewProps | null>(null);
  const [facebookResponseData, setFacebookResponseData] = useState<
    FLR | FLR_BS | null
  >(null);
  const [
    instagramResponseData,
    setInstagramResponseData,
  ] = useState<InstagramResponseData | null>(null);
  const [isOrderFinished, setIsOrderFinished] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    // FLR_BS
    if (BrowserStorage.getStorageItem("fbAuthData")) {
      let localFbAuthData: FLR_BS = JSON.parse(
        BrowserStorage.getStorageItem("fbAuthData")
      );
      setFacebookResponseData({
        ...localFbAuthData,
      });
    }
  }, []);

  useEffect(() => {
    if (isLoading) {
      editPageScrollScroll("hidden");
    } else {
      editPageScrollScroll("auto");
    }
  }, [isLoading]);

  const providerValue = {
    globalLoader,
    setGlobalLoader,
    editPageScrollScroll,
    productPreview,
    setProductPreview,
    isLoading,
    setIsLoading,
    isOrderFinished,
    setIsOrderFinished,
    facebookResponseData,
    setFacebookResponseData,
    instagramResponseData,
    setInstagramResponseData,
  };

  return (
    <AppContext.Provider value={providerValue}>
      <>
        {children}
        {isLoading && <CanvasLoader />}
      </>
    </AppContext.Provider>
  );
}

export default AppProvider;

export function toggleActiveStepByIndex(index: number) {
  let steps = document.getElementsByClassName("js-create-paper-steps");
  for (let i = 0; i < steps.length; i++) {
    const element = steps[i];
    if (i === index) {
      element.classList.add("active");
    } else {
      element.classList.remove("active");
    }
  }
}

export function editPageScrollScroll(overflow: "hidden" | "auto") {
  if (document) {
    switch (overflow) {
      case "hidden":
        document.body.style.overflow = overflow;
        break;

      case "auto":
        document.body.style.overflow = overflow;
        break;

      default:
        break;
    }
  }
}
